// extracted by mini-css-extract-plugin
export default {"main":"page_main__tZHqe","nav":"page_nav__jHPSs","container":"page_container__hszYQ","danger":"page_danger__JpxLG","linkbtn":"page_linkbtn__hyfDw"};